import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { UserPermissionService, CONFIGURATION_USER_ROLE } from '../services/user-permission-service';

const useUserRoles = () => useSelector(Global.selectUseruserRoles);

export const useUserRole = (roleName) => {
  const userRoles = useUserRoles();
  return UserPermissionService.userIsInRoleOrHasAdministrationPermission(userRoles, roleName);
};

export const useUserHasConfigurationRole = () => useUserRole(CONFIGURATION_USER_ROLE);

export const useUserHasOrderManagementRole = () => {
  return UserPermissionService.userHasOrderManagementRole(useUserRoles());
};

export const useUserHasOrderViewRestriction = () => useSelector(Global.selectUseruserHasOrderViewRestriction);

export const useUserHasShippingRole = () => UserPermissionService.userHasShippingRole(useUserRoles());

export const useUserHasPurchasingRole = () => {
  const roles = useUserRoles();
  return UserPermissionService.userHasAdministrationRole(roles) || UserPermissionService.userHasPurchasingRole(roles);
};

export const useUserHasAdministrationRole = () => {
  const userRoles = useUserRoles();
  return UserPermissionService.userHasAdministrationRole(userRoles);
};

export const useUserHasAccountManagementRole = () =>
  useSelector((state) => {
    const userRoles = Global.selectUseruserRoles(state);
    return UserPermissionService.userHasAccountManagementRole(userRoles);
  });

export const useUserHasAnalyticsExploreRole = () => UserPermissionService.userHasAnalyticsExploreRole(useUserRoles());

export const useUserHasAnalyticsViewRole = () => UserPermissionService.userHasAnalyticsViewRole(useUserRoles());

export const useUserHasEditSerialNumbersRole = () => UserPermissionService.userHasEditSerialNumbersRole(useUserRoles());
